<!-- @format -->

<template>
    <v-card class="mx-auto" outlined :dark="isDark" :min-width="cardMinWidth" :max-width="cardMaxWidth"
        :min-height="cardMinHeight" :color="cardColor" elevation="4" :tile="true">
        <v-container>
            <v-row no-gutters justify="center">
                <v-row no-gutters justify="center">
                    <!-- <v-col cols="2" xs="0" sm="0" md="2" class="flex-grow-0 flex-shrink-0"></v-col> -->
                    <v-col cols="8" xs="0" sm="0" md="8" class="flex-grow-0 flex-shrink-0">
                        <v-select v-model="anyo" :items="itemsAnyo" outlined @change="loadChart($event)"
                            hint="Selecciona Año" persistent-hint>
                            <template v-slot:selection="{ item }">
                                <span class="d-flex justify-center" style="width: 100%;">
                                    {{ item }}
                                </span>
                            </template>
                        </v-select>

                    </v-col>
                    <!-- <v-col cols="2" class="mb-4"></v-col>
            <v-col cols="3" class="mb-4">
                <br>TOTAL: {{ totalBeneficios }}
            </v-col> -->
                </v-row>
                <v-row no-gutters justify="center">
                    <v-col cols="12" xs="0" sm="0" md="12" class="flex-grow-0 flex-shrink-0">
                        <apexchart ref="realtimeChart" v-if="loaded" type="line" height="200" :options="chartOptions"
                            :series="series" />
                    </v-col>

                </v-row>
                <!-- <v-row>
            <apexchart ref="realtimeChart" v-if="loaded" type="line" height="200" :options="chartOptions"
                :series="series" />
        </v-row> -->

            </v-row>
        </v-container>
    </v-card>


</template>

<script>
import UserService from '../../services/user.service'

export default {
    name: 'DataChartHome',
    props: {
        cardMinHeight: {
            default: '100',
        },
        cardMinWidth: {
            default: '300',
        },
        cardMaxWidth: {
            default: '600',
        },
        cardTitle: {
            default: 'Materialfy Basic Card',
        },
        cardSubHeaderText: {
            default: 'Subheader',
        },
        cardIcon: {
            default: 'crdIcon',
        },
        cardInner: {
            default: 'crdInner',
        },
        cardActions: {
            default: 'crdActions',
        },
        cardHeaderColor: {
            default: 'tertiary',
        },
        cardColor: {
            default: 'primary',
        },
        cardAvatar: {
            default: 'crdAvatar',
        },
        cardAutomatic: {
            default: 'crdAutomatic',
        },
        isDark: {
            default: false,
        },
        cardShowDivider: {
            default: true,
        },
        cardShowActions: {
            default: true,
        },
        cardShowInner: {
            default: true,
        },
        cardShowAvatar: {
            default: true,
        },
        cardShowTitle: {
            default: true,
        },
        cardShowSubHeader: {
            default: true,
        },
        cardShowAutomatic: {
            default: true,
        },
        data: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            loaded: true,
            // Chart
            anyo: '',
            itemsAnyo: [2024, 2025],
            series: [
                {
                    name: 'Beneficios',
                    data: [10, 41, 35, 51, 49, 62, 69, 91, 99, 42, 45, 75],
                },
            ],
            chartOptions: {
                colors: ['#FCCF31', '#17ead9', '#f02fc2'],
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 1000,
                },
                chart: {
                    height: 350,
                    type: 'line',
                },
                grid: {
                    show: true,
                    strokeDashArray: 0,
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                },
                stroke: {
                    curve: 'smooth',
                },
                dropShadow: {
                    enabled: true,
                    opacity: 0.3,
                    blur: 5,
                    left: -7,
                    top: 22,
                },
                dataLabels: {
                    enabled: false,
                },
                title: {
                    text: 'Beneficios generados por el Bot',
                    align: 'left',
                    style: {
                        color: '#FFF',
                    },
                },
                xaxis: {
                    categories: ['Enero', 'Febrero', 'Marzo', 'Abril',
                        'Mayo', 'Junio', 'Julio', 'Agosto',
                        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    labels: {
                        style: {
                            colors: '#fff',
                        },
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: '#fff',
                        },
                    },
                },
            },
        }
    },
    mounted() {
        // this.setDataLineChart()
        this.anyo = this.itemsAnyo[1]
        this.loaded = false
        this.chartOptions.title.text = this.cardTitle
        this.loadChart(this.anyo)
    },
    methods: {
        loadChart(value) {
            // console.log(value)
            // this.chartData.datasets[0].data = [];
            this.loaded = false
            UserService.getChartInfo(value).then(
                response => {
                    // console.log(response.data)
                    this.chartBeneficios = response.data.beneficios
                    this.totalComisiones = response.data.comisiones
                    this.totalBeneficios = response.data.totalBeneficios
                    // console.log(this.chartBeneficios)
                    this.series[0].data = []
                    if (this.chartBeneficios !== null && this.chartBeneficios !== undefined) {
                        for (let index = 0; index < this.chartBeneficios.length; index++) {
                            this.series[0].data.push(this.chartBeneficios[index].beneficios.toFixed(2))
                        }
                        this.loaded = true
                    }
                    // this.$refs.dashBoard.loadData(this.chartBeneficios)

                },
                error => {
                    this.content =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        getRandomArbitrary() {
            return Math.floor(Math.random() * 99)
        },
        setDataLineChart() {
            setInterval(() => {
                this.series[0].data.splice(0, 1)
                this.series[0].data.push(this.getRandomArbitrary(0, 99))
                this.updateSeriesLine()
            }, 3000)
        },
        updateSeriesLine() {
            // eslint-disable-next-line no-use-before-define
            this.$refs.realtimeChart.updateSeries(
                [
                    {
                        data: this.series[0].data,
                    },
                ],
                false,
                true
            )
        },
    },
}
</script>
